import { motion } from 'motion/react';
import type { FC } from 'react';
import { Table } from '.';
import type { TableAnimatableRowProps } from './table.types';

export const TableAnimatableRow: FC<TableAnimatableRowProps> = (props) => (
  <Table.Row as={motion.tr} {...props} />
);
